import hljs from 'highlight.js';

const SELECTOR = 'pre > code.hljs';

const Code = {
    init: ($scope, workerUrl) => {
        if (!$scope) {
            $scope = $(document);
        }

        const worker = new Worker(workerUrl);

        worker.onmessage = () => {
            $scope.find(SELECTOR).each(function () {
                hljs.highlightElement(this);
            });
        };

        worker.postMessage(true);
    },
};

export default Code;
